var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 1.5C4.785 1.5 3.1875 3.0975 3.1875 5.0625C3.1875 6.99 4.695 8.55 6.66 8.6175C6.72 8.61 6.78 8.61 6.825 8.6175C6.84 8.6175 6.8475 8.6175 6.8625 8.6175C6.87 8.6175 6.87 8.6175 6.8775 8.6175C8.7975 8.55 10.305 6.99 10.3125 5.0625C10.3125 3.0975 8.715 1.5 6.75 1.5Z",
    fill: "url(#paint0_linear_6369_36493)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5597 10.6127C8.46723 9.21766 5.05473 9.21766 2.94723 10.6127C1.99473 11.2502 1.46973 12.1127 1.46973 13.0352C1.46973 13.9577 1.99473 14.8127 2.93973 15.4427C3.98973 16.1477 5.36973 16.5002 6.74973 16.5002C8.12973 16.5002 9.50973 16.1477 10.5597 15.4427C11.5047 14.8052 12.0297 13.9502 12.0297 13.0202C12.0222 12.0977 11.5047 11.2427 10.5597 10.6127Z",
    fill: "url(#paint1_linear_6369_36493)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.992 5.50556C15.112 6.96056 14.077 8.23556 12.6445 8.40806C12.637 8.40806 12.637 8.40806 12.6295 8.40806H12.607C12.562 8.40806 12.517 8.40806 12.4795 8.42306C11.752 8.46056 11.0845 8.22806 10.582 7.80056C11.3545 7.11056 11.797 6.07556 11.707 4.95056C11.6545 4.34306 11.4445 3.78806 11.1295 3.31556C11.4145 3.17306 11.7445 3.08306 12.082 3.05306C13.552 2.92556 14.8645 4.02056 14.992 5.50556Z",
    fill: "url(#paint2_linear_6369_36493)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4922 12.4428C16.4322 13.1703 15.9672 13.8003 15.1872 14.2278C14.4372 14.6403 13.4922 14.8353 12.5547 14.8128C13.0947 14.3253 13.4097 13.7178 13.4697 13.0728C13.5447 12.1428 13.1022 11.2503 12.2172 10.5378C11.7147 10.1403 11.1297 9.8253 10.4922 9.5928C12.1497 9.1128 14.2347 9.4353 15.5172 10.4703C16.2072 11.0253 16.5597 11.7228 16.4922 12.4428Z",
    fill: "url(#paint3_linear_6369_36493)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6369_36493",
    x1: 6.75,
    y1: 1.5,
    x2: 6.75,
    y2: 8.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6369_36493",
    x1: 6.74973,
    y1: 9.56641,
    x2: 6.74973,
    y2: 16.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6369_36493",
    x1: 12.7918,
    y1: 3.04297,
    x2: 12.7918,
    y2: 8.42699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6369_36493",
    x1: 13.4963,
    y1: 9.375,
    x2: 13.4963,
    y2: 14.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/multi-users.482269ae83e08574e546106c44540b06.svg";
export { ForwardRef as ReactComponent };